
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { HtmlMarkup } from "../../lib/processHtml";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import useFetchPage from "../../lib/hooks/use-fetch-page";



//
export default  function TermsDetail() {
  const user =  getCurrentUser();
  const { data:res,loading } = useFetchPage({ slug: "terms", endpoint: "fetch_page" });
  const page = res.status
    ? res.data
    : { title: "Terms -  HiGorgeous", description: "Error fetching page" };

  return (
    <>
      <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <span>Terms</span>
        </div>
      </div>

      <div className="flex flex-row border-bottom align-items-center px20 py10">
        <span className="group-btn">
          <Link to="#">
            <span className="sm-hide px5">Publish</span>
          </Link>
        </span>
        <span className="spacer align-items-center justify-content-center">
          -
        </span>
        <span className="group-btn">
          <Link to="/admin/terms/edit">
            <FaEdit /> <span className="sm-hide px5">Edit</span>
          </Link>
        </span>
      </div>

      <div className="dashboard-page-content">
        <HtmlMarkup word={page.description} />
      </div>
    </>
  );
}
